var React = require('react');

function NavIconInstitutional (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.51px;}")),React.createElement("title",{"key":1},"navIcon-institutional"),React.createElement("path",{"className":"a","d":"M9.59,6.11A3.25,3.25,0,0,0,7.13,7.7L6,6.86A4.46,4.46,0,0,1,9.59,4.75c1.78,0,2.89,1,2.89,2.42s-1.25,2.1-2.4,2.31v.78H8.47V8.59C9.83,8.49,11,8.14,11,7.21,11,6.51,10.35,6.11,9.59,6.11ZM9.2,10.82A1.15,1.15,0,1,1,8.05,12,1.16,1.16,0,0,1,9.2,10.82Z","key":2}),React.createElement("circle",{"className":"b","cx":"9","cy":"9","r":"8.14","key":3})]);
}

NavIconInstitutional.defaultProps = {"viewBox":"0 0 18 18"};

module.exports = NavIconInstitutional;

NavIconInstitutional.default = NavIconInstitutional;
